export enum ChargingType {
  Slow = 0,
  Fast = 1,
  UltraFast = 2
}

export enum ChargingTypeLabel {
  Slow = "AC",
  Fast = "DC",
  UltraFast = "HPC"
}